import React, {Component} from 'react';
import {
  Badge,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Table,
  Pagination,
  PaginationItem,
  PaginationLink,
  Button
} from 'reactstrap';
import Paging from './Paging';
import SmartForm from '../SmartForm';
import './Grid.scss';


class Grid extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filterValues: this.defaultFilterValues()
    }

    this.submitFilters = this.submitFilters.bind(this);
    this.resetFilters = this.resetFilters.bind(this);

  }

  defaultFilterValues() {
    return this.props.filter !== null ? this.props.filter.fields.reduce((map, field) => {
      map[field.id] = "";
      return map;
    }, {}) : {}
  }

  renderHeaderRow() {
    return (
      <tr>
        {this.props.columns.map(column => {
          let style = {};
          if ( column.minWidth ) {
            style["minWidth"] = column.minWidth;
          }
          if ( column.width ) {
            style["width"] = column.width;
          }
          if ( column.maxWidth ) {
            style["maxWidth"] = column.maxWidth;
          }
          return (<th
            style={style}
            key={column.key}>{column.name}</th>);
        })}
      </tr>
    );
  }

  renderRow(row, index) {
    return (
      <tr key={index}>
        {
          this.props.columns.map(column => {
            return (<td key={column.key}>
              {this.displayValue(column, row)}
              </td>
            );
          })
        }
      </tr>
    );
  }

  displayValue(column, row) {
    let type = column.type || "";
    let value = row[column.key];
    switch(type) {
      case "datetime":
        return this.formatDate(new Date(value));
        break;
      case "string":
        return this.formatString(column, value);
        break;
      case "custom":
        return column.render(row);
      default:
        return value;
        break;
    };
  }

  formatString(column, value) {
    if ( typeof column["query"] !== 'undefined'
      && typeof column.query[value] !== 'undefined' ) {
        return column.query[value];
    } else {
      return value;
    }
  }

  formatDate(date) {
    return this.padZeroes(4, date.getFullYear()) + "-"
          + this.padZeroes(2, date.getMonth() + 1) + "-"
          + this.padZeroes(2, date.getDate()) + " "
          + this.padZeroes(2, date.getHours()) + ":"
          + this.padZeroes(2, date.getMinutes()) + ":"
          + this.padZeroes(2, date.getSeconds());
  }

  padZeroes(numberOfZeroes, value) {
    return (Array(numberOfZeroes).join("0") + value).slice(-numberOfZeroes);
  }

  renderPaging() {
    if ( this.props.pagination ) {
      return (
        <Paging
          currentPage={parseInt(this.props.currentPage)}
          maxPage={Math.ceil(parseInt(this.props.total) / parseInt(this.props.perPage))}
          onChangePage={this.props.onChangePage} />
      )
    }
  }

  renderData() {
    if ( this.props.data.length > 0 ) {
      return this.props.data.map((row, index) => {
        return this.renderRow(row, index);
      })
    } else {
      return (
        <tr>
          <td className={"text-center"} colSpan={this.props.columns.length}>
            No data available.
          </td>
        </tr>
      );
    }
  }

  setFilterValue(field, value) {
    this.setState({
      filterValues: {
        ...this.state.filterValues,
        [field]: value
      }
    })
  }

  submitFilters() {
    this.props.onSubmitFilters(this.state.filterValues);
  }

  resetFilters() {
    this.setState({
      filterValues: this.defaultFilterValues()
    }, () => {
      this.props.onSubmitFilters(this.state.filterValues);
    });
  }

  getFilterFormButtons() {
    return [
      <Button color="success" onClick={(e) => this.submitFilters()}>Filter</Button>,
      <Button onClick={(e) => this.resetFilters()}>Reset</Button>
    ]
  }

  renderFilters() {
    if ( this.props.filter !== null ) {
      let form = {
        fields: this.props.filter.fields
      }
      return (
        <SmartForm
          form={form}
          buttons={this.getFilterFormButtons()}
          columns={2}
          formValues={this.state.filterValues}
          onSetFormValue={(field, value) => this.setFilterValue(field, value)}
          onSubmit={this.submitFilters}
          footer={false} />
      );
    }
  }

  render() {
    return (
      <div className="animated fadeIn">
        {this.renderFilters()}
        {this.props.showTotal && `Total ${this.props.total} records`}
        <Table className="Grid" responsive striped>
          <thead>
            {this.renderHeaderRow()}
          </thead>
          <tbody>
            {this.renderData()}
          </tbody>
        </Table>
        {this.renderPaging()}
      </div>
    )
  }
}

Grid.defaultProps = {
  filter: null,
  columns: [],
  data: [],
  total: 0,
  currentPage: 0,
  perPage: 20,
  pagination: true,
  showTotal: true,
  onSubmitFilters: (filters) => {},
  onChangePage: (page) => {}
};

export default Grid;



// WEBPACK FOOTER //
// ./src/components/Grid/Grid.js